(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-drawer"] && !Shopify.designMode) return;
  try {
    (function () {
    var SECTION_ID = 'header';

    function initCartDrawer() {
      var dialog = document.querySelector('[data-cart-drawer]');
      if (!dialog || dialog.dataset.ready) return;
      dialog.dataset.ready = 'true';

      function openDrawer() {
        if (typeof dialog.showModal === 'function') {
          if (!dialog.open) dialog.showModal();
        } else {
          dialog.setAttribute('open', '');
        }
      }

      function closeDrawer() {
        if (typeof dialog.close === 'function') dialog.close();
        else dialog.removeAttribute('open');
      }

      function syncHeaderCount() {
        var content = dialog.querySelector('[data-cart-drawer-content]');
        if (!content) return;
        var count = content.getAttribute('data-cart-count') || '0';
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          if (el === content) return;
          el.textContent = count;
          el.classList.toggle('is-empty', count === '0');
        });
      }

      function applyHTML(htmlString) {
        var parsed = new DOMParser().parseFromString(htmlString, 'text/html');
        var fresh = parsed.querySelector('[data-cart-drawer-content]');
        var current = dialog.querySelector('[data-cart-drawer-content]');
        if (fresh && current) {
          current.innerHTML = fresh.innerHTML;
          current.setAttribute('data-cart-count', fresh.getAttribute('data-cart-count') || '0');
        }
        syncHeaderCount();
      }

      function refresh(shouldOpen) {
        return fetch(window.location.pathname + '?sections=' + SECTION_ID)
          .then(function (res) { return res.json(); })
          .then(function (data) { if (data[SECTION_ID]) applyHTML(data[SECTION_ID]); })
          .catch(function () {})
          .then(function () { if (shouldOpen) openDrawer(); });
      }

      function showDrawerMessage(msg) {
        var drawerEl = document.querySelector('[data-cart-drawer]');
        if (!drawerEl) return;
        var el = drawerEl.querySelector('[data-drawer-message]');
        if (!el) {
          el = document.createElement('p');
          el.className = 'cart-drawer__message';
          el.setAttribute('data-drawer-message', '');
          el.setAttribute('role', 'status');
          drawerEl.insertBefore(el, drawerEl.firstChild);
        }
        el.textContent = msg;
        el.hidden = false;
        clearTimeout(el._hideTimer);
        el._hideTimer = setTimeout(function () { el.hidden = true; }, 5000);
      }

      function mutate(url, body) {
        body.sections = SECTION_ID;
        return fetch(url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(body)
        })
          .then(function (res) {
            if (!res.ok) {
              return res.json().catch(function () { return {}; }).then(function (err) {
                showDrawerMessage(err.message || err.description || 'Sorry — that item can’t be updated right now.');
                return refresh(false);
              });
            }
            return res.json().then(function (data) {
              if (data.sections && data.sections[SECTION_ID]) applyHTML(data.sections[SECTION_ID]);
              else return refresh(false);
            });
          })
          .catch(function () { return refresh(false); });
      }

      dialog.addEventListener('click', function (event) {
        if (event.target === dialog) { closeDrawer(); return; }

        if (event.target.closest('[data-cart-close]')) { event.preventDefault(); closeDrawer(); return; }

        var addBtn = event.target.closest('[data-upsell-add]');
        if (addBtn) {
          event.preventDefault();
          addBtn.disabled = true;
          mutate('/cart/add.js', { id: addBtn.getAttribute('data-variant-id'), quantity: 1 });
          return;
        }

        var row = event.target.closest('[data-line-key]');
        if (!row) return;
        var key = row.getAttribute('data-line-key');
        var valEl = row.querySelector('.cart-drawer__qty-val');
        var qty = valEl ? parseInt(valEl.textContent, 10) || 0 : 0;

        if (event.target.closest('[data-qty-down]')) {
          event.preventDefault();
          mutate('/cart/change.js', { id: key, quantity: Math.max(0, qty - 1) });
        } else if (event.target.closest('[data-qty-up]')) {
          event.preventDefault();
          mutate('/cart/change.js', { id: key, quantity: qty + 1 });
        } else if (event.target.closest('[data-remove]')) {
          event.preventDefault();
          mutate('/cart/change.js', { id: key, quantity: 0 });
        }
      });

      document.querySelectorAll('[data-cart-toggle]').forEach(function (el) {
        el.addEventListener('click', function (event) {
          event.preventDefault();
          refresh(true);
        });
      });

      document.addEventListener('cart:refresh', function () {
        refresh(true);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initCartDrawer);
    } else {
      initCartDrawer();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["search-overlay"] && !Shopify.designMode) return;
  try {
    (function () {
    function initSearchOverlay() {
      var dialog = document.querySelector('[data-search-overlay]');
      if (!dialog || dialog.dataset.ready) return;
      dialog.dataset.ready = 'true';

      var input = dialog.querySelector('[data-search-input]');
      var results = dialog.querySelector('[data-search-results]');
      var controller = null;
      var debounceTimer = null;

      function openOverlay() {
        if (typeof dialog.showModal === 'function') {
          if (!dialog.open) dialog.showModal();
        } else {
          dialog.setAttribute('open', '');
        }
        requestAnimationFrame(function () { input.focus(); });
      }

      function closeOverlay() {
        if (typeof dialog.close === 'function') dialog.close();
        else dialog.removeAttribute('open');
      }

      function clearResults() {
        results.innerHTML = '';
      }

      function fetchResults(term) {
        if (controller) controller.abort();
        controller = new AbortController();
        var url = '/search/suggest?q=' + encodeURIComponent(term) +
          '&section_id=predictive-search' +
          '&resources[type]=product,collection,query' +
          '&resources[limit]=6' +
          '&resources[options][unavailable_products]=last';

        fetch(url, { signal: controller.signal })
          .then(function (res) { return res.text(); })
          .then(function (html) {
            var parsed = new DOMParser().parseFromString(html, 'text/html');
            var fresh = parsed.querySelector('[data-predictive-results]');
            results.innerHTML = fresh ? fresh.outerHTML : '';
          })
          .catch(function () {});
      }

      input.addEventListener('input', function () {
        var term = input.value.trim();
        clearTimeout(debounceTimer);
        if (term.length < 2) {
          if (controller) controller.abort();
          clearResults();
          return;
        }
        debounceTimer = setTimeout(function () { fetchResults(term); }, 250);
      });

      dialog.addEventListener('click', function (event) {
        if (event.target === dialog) { closeOverlay(); return; }
        if (event.target.closest('[data-search-close]')) { event.preventDefault(); closeOverlay(); }
      });

      document.querySelectorAll('[data-search-toggle]').forEach(function (el) {
        el.addEventListener('click', function (event) {
          event.preventDefault();
          openOverlay();
        });
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initSearchOverlay);
    } else {
      initSearchOverlay();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
